import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../../contents/ganttDiagram/Layout';
import SEO from '../../components/seo';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = Layout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <SEO title="Learn Gantt diagrams" description="Learn how to turn code into Gantt diagrams and integrate it in one click in GitHub, Notion, and more." mdxType="SEO" />
    <h1>{`Gantt diagram `}<em parentName="h1">{`Learn`}</em></h1>
    <h2>{`What are Gantt diagrams?`}</h2>
    <p>{`Gantt diagrams are a type of chart that illustrates a project schedule, named after its inventor, Henry Gantt.
It let's you visualize what tasks are executed in parallel, and in which order.`}</p>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      